module.exports = __webpack_public_path__ + "static/img/xinfeng-wai-active.1e391829.png";